/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var Object = require( '@stdlib/object-ctor' );


// VARIABLES //

var propertySymbols = Object.getOwnPropertySymbols;


// MAIN //

/**
* Returns an array of an object's own symbol properties.
*
* ## Notes
*
* -   In contrast to the built-in `Object.getOwnPropertySymbols()`, this function returns an empty array if provided `undefined` or `null`, rather than throwing an error.
*
* @private
* @param {*} value - input object
* @returns {Array} a list of own symbol properties
*
* @example
* var symbols = getOwnPropertySymbols( {} );
*/
function getOwnPropertySymbols( value ) {
	return propertySymbols( Object( value ) );
}


// EXPORTS //

module.exports = getOwnPropertySymbols;
